import React from 'react';
import { ArticleItemProps } from '../types/typedeclaration';
 import { activetabslice } from '../store/navigationSlice';
  import { useAppDispatch } from '../store/hooks';
import { Link } from 'react-router-dom';
import Loader from './Loader';
import { HEADING_STYLE_DARK_MODE, HEADING_STYLE_LIGHT_MODE } from '../Config/config';
const LoadmorenewsBox: React.FC<ArticleItemProps> = ({
  darkMode,
  fontSize, 
  inlineView,
  articles,
  title
}) => { 
   const dispatch = useAppDispatch(); 
    const [loading, setLoading] = React.useState(false)

  return (
    <div className={`${inlineView ? ('z-20'):('fixed inset-0')} pb-4 ${darkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>

        {loading ? (<Loader darkMode={darkMode} />):(<>
          <div className={`container mx-auto py-0 ${inlineView && ('px-3')}`}>
            <h2 className={`text-xl font-bold mb-2 ${darkMode ? HEADING_STYLE_DARK_MODE : HEADING_STYLE_LIGHT_MODE}`}>{title}</h2>            
            <div className={`grid gap-4 ${!inlineView && ('overflow-y-scroll max-h-[calc(100vh-150px)]')}`}>
              {/* Featured Video */}
              {articles && Array.isArray(articles) && articles?.length > 0 && (
                articles.slice(0,1).map((item)=> {
                  return (<div key={item?.id} className={`rounded-lg overflow-hidden shadow-lg ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div className="relative">
                  <Link id={item?.post_slug} to={`/news/${item?.post_slug}`}>
                  <img 
                    src={item?.post_featured_image_thumb ? item?.post_featured_image_thumb : item?.post_featured_image} 
                    alt="Featured Video" 
                    className="w-full h-48 object-cover"
                  />                 
                  </Link>               
                  <div className="absolute bottom-0 right-0 bg-red-600 text-white px-2 py-1 text-xs">
                    {item?.location}
                  </div>
                </div>
                <div className="p-3">
                  <Link id={item?.post_slug} to={`/news/${item?.post_slug}`}>
                  <h3 className={`font-bold mb-1 ${
                    fontSize === 'small' ? 'text-base' : 
                    fontSize === 'large' ? 'text-xl' : 'text-lg'
                  }`}>
                    {item?.post_title}
                  </h3>
                  </Link>
                  <p className={`${
                    darkMode ? 'text-gray-300' : 'text-gray-600'
                  } mb-2 ${
                    fontSize === 'small' ? 'text-xs' : 
                    fontSize === 'large' ? 'text-base' : 'text-sm'
                  }`}>
                    {/* description */}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                      <i className="far fa-clock mr-1"></i> {item?.created}
                    </span>
                    {/* <span className={`text-xs px-2 py-1 rounded ${
                      darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                    }`}>
                      {item?.user}
                    </span> */}
                  </div>
                </div>
              </div>)
                })
              )}
              
              
              {/* news List */}
              {Array.isArray(articles) && articles?.length > 1 &&  articles?.slice(1).map((item) => (
                <div key={item.id} className={`rounded-lg overflow-hidden shadow-md ${
                  darkMode ? 'bg-gray-800' : 'bg-white'
                } flex`}>
                  <div className="w-2/5 relative">
                   <Link id={item?.post_slug} to={`/news/${item?.post_slug}`}>
                    <img 
                      src={item?.post_featured_image_thumb ? item?.post_featured_image_thumb : item?.post_featured_image} 
                      alt={item.post_title} 
                      className="w-full h-full object-cover"
                    /></Link>
                    <div className="absolute bottom-1 right-1 bg-black bg-opacity-70 text-white px-1 text-xs">
                      {item.location}
                    </div>
                  </div>
                  <div className="w-3/5 p-2">
                   <Link id={item?.post_slug} to={`/news/${item?.post_slug}`}>
                    <h3 className={`font-medium ${
                      fontSize === 'small' ? 'text-sm' : 
                      fontSize === 'large' ? 'text-lg' : 'text-base'
                    } line-clamp-2`}>
                      {item.post_title}
                    </h3>
                    </Link>
                    <div className="flex justify-between items-center mt-2">
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {item.user}
                      </span>                     
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div></>)}
        

          

          

        </div>
  )
}
export default LoadmorenewsBox;